import type { FunctionComponent } from 'react';
import React, { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { CardTemplatesButtonProps } from './CardTemplatesButton';

export const LazyCardTemplatesButton: FunctionComponent<
  CardTemplatesButtonProps
> = (props) => {
  const CardTemplatesButton = useLazyComponent(
    () =>
      import(/* webpackChunkName: "card-templates" */ './CardTemplatesButton'),
    { namedImport: 'CardTemplatesButton' },
  );

  return (
    <ErrorBoundary
      tags={{ ownershipArea: 'trello-aaaa', feature: 'Card Templates' }}
    >
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <CardTemplatesButton {...props} />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );
};
